import {connect} from 'react-redux';
import * as ModalActions from '../../actions/ModalActions';
import {withRouter} from 'react-router';
import PayWarrantyRefusedView from '../../components/views/mx/PayWarrantyRefusedView';

const mapDispatchToProps = (dispatch) => {
    return {
        onPressNext: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
    };
};

const PayWarrantyRefusedContainer = withRouter<any, any>(connect(
    null,
    mapDispatchToProps,
    mergeProps
)(PayWarrantyRefusedView));

export default PayWarrantyRefusedContainer;